export const StatusBarBgGrid = {
  size: 100,
  gap: 0,
  name: 'statusbarbg',
  padding: {
    left: 5,
    right: 5,
    portrate: {
      left: 5,
      right: 5,
    },
  },
  main: [
    {
      name: 'statusbarbg1',
      size: 97,
      type: 'PortrateGridController',
      config: {
        name: 'statusbarbg2',
        size: 100,
        gap: 0,
        align: 'left',
        hide: ['status_bar_mobile'],
        main: [
          {
            name: 'status_bar_mobile',
            size: 6,
            visible: false,
          },
        ],
      },
    },
  ],
  landscape: [
    {
      name: 'empty',
      size: 49,
    },
    {
      name: 'statusbarbg1_landscape',
      size: 6,
      type: 'LandscapeGridController',
      config: {
        name: 'statusbarbg2',
        size: 100,
        gap: 0,
        maxWidth: 'reel',
        align: 'left',
        hide: ['status_bar_mobile'],
        main: [
          {
            name: 'status_bar_mobile',
            // size: 100,
          },
        ],
      },
    },
  ],
  portrate: [
    {
      name: 'empty',
      size: 50,
    },
    {
      name: 'statusbarbg1-mobile',
      size: 6,
      type: 'LandscapeGridController',
      config: {
        name: 'statusbarbg2-mobile',
        size: 100,
        gap: 0,
        maxWidth: 'reel',
        align: 'center',
        unhide: ['status_bar_mobile'],
        main: [
          {
            name: 'status_bar_mobile',
            size: 100,
            bounds: {
              width: 439,
              height: 48,
            },
          },
        ],
      },
    },
  ],
};
